import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Notes } from '@app/core/Enum/note';
import { CommonService } from '@app/core/Services';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-note-1',
  templateUrl: './note-1.component.html',
  styleUrls: ['./note-1.component.scss'],
})
export class Note1Component implements OnInit {
  note1Form: FormGroup;

  @Input() triggerEditData: Observable<any>;
  notes = [
    { title: 'Accounting Policies' },
    { title: 'Basis of preparation' },
    { title: 'Going concern' },
    { title: 'Change of accounting policy' },
    { title: 'Changes to accounting estimates' },
    { title: 'Material prior year errors' },
    {
      title:
        'Reconciliation with previous Generally accepted accounting practice',
    },
    { title: 'Income from donations or grants' },
    { title: 'Legacies' },
    { title: 'Government grants' },
    { title: 'Tax reclaims on donations and gifts' },
    { title: 'Contractual income and performance related grants' },
    { title: 'Donated goods' },
    { title: 'Donated services and facilities' },
    { title: 'Income from charitable activities' },
    { title: 'Investment income' },
    { title: 'Income from membership subscriptions' },
    { title: 'Other trading income' },
    { title: 'Settlement of insurance claims' },
    { title: 'Investment gains and losses' },
    { title: 'Expenditure' },
    { title: 'Pensions' },
    { title: 'Taxation' },
    { title: 'Creditors' },
    { title: 'Provisions for liabilities' },
    { title: 'Financial instruments' },
    { title: 'Fund accounting' },
    { title: 'Critical accounting estimates and judgements' },
    { title: 'Intangible fixed assets' },
    { title: 'Tangible fixed assets' },
    { title: 'Heritage assets' },
    { title: 'Investments' },
    { title: 'Investment properties' },
    { title: 'Stocks and work in progress' },
    { title: 'Debtors' },
    { title: 'Current asset investments' },
  ];

  constructor(public commonService: CommonService) {}

  ngOnInit(): void {
    this.setForm();
    this.triggerEditData?.subscribe((data) => {
      this.setForm();

      if (
        data.noteId === Notes.Note1 &&
        data.response.userInputData !== null &&
        data.response.userInputData !== undefined &&
        data.response.userInputData.data !== null &&
        data.response.userInputData.data !== undefined
      ) {
        this.editNotes1(data.response.userInputData.data);
        this.editCheckboxNote1(data.response.userInputData.checkBoxData);
      }
    });
  }

  setForm(): void {
    this.note1Form = new FormGroup({
      textbox1: new FormControl(''),
      textbox2: new FormControl(''),
      textbox3: new FormControl(''),
      textbox4: new FormControl(''),
      textbox5: new FormControl(''),
      textbox6: new FormControl(''),
      textbox7: new FormControl(''),
      textbox8: new FormControl(''),
      textbox9: new FormControl(''),
      textbox10: new FormControl(''),
      textbox11: new FormControl(''),
      textbox12: new FormControl(''),
      textbox13: new FormControl(''),
      textbox14: new FormControl(''),
      textbox15: new FormControl(''),
      textbox16: new FormControl(''),
      textbox17: new FormControl(''),
      textbox18: new FormControl(''),
      textbox19: new FormControl(''),
      textbox20: new FormControl(''),
      textbox21: new FormControl(''),
      textbox22: new FormControl(''),
      textbox23: new FormControl(''),
      textbox24: new FormControl(''),
      textbox25: new FormControl(''),
      textbox26: new FormControl(''),
      textbox27: new FormControl(''),
      textbox28: new FormControl(''),
      textbox29: new FormControl(''),
      textbox30: new FormControl(''),
      textbox31: new FormControl(''),
      textbox32: new FormControl(''),
      textbox33: new FormControl(''),
      textbox34: new FormControl(''),
      textbox35: new FormControl(''),
      textbox36: new FormControl(''),

      checkbox1: new FormControl(0),
      checkbox2: new FormControl(0),
      checkbox3: new FormControl(0),
      checkbox4: new FormControl(0),
      checkbox5: new FormControl(0),
      checkbox6: new FormControl(0),
      checkbox7: new FormControl(0),
      checkbox8: new FormControl(0),
      checkbox9: new FormControl(0),
      checkbox10: new FormControl(0),
      checkbox11: new FormControl(0),
      checkbox12: new FormControl(0),
      checkbox13: new FormControl(0),
      checkbox14: new FormControl(0),
      checkbox15: new FormControl(0),
      checkbox16: new FormControl(0),
      checkbox17: new FormControl(0),
      checkbox18: new FormControl(0),
      checkbox19: new FormControl(0),
      checkbox20: new FormControl(0),
      checkbox21: new FormControl(0),
      checkbox22: new FormControl(0),
      checkbox23: new FormControl(0),
      checkbox24: new FormControl(0),
      checkbox25: new FormControl(0),
      checkbox26: new FormControl(0),
      checkbox27: new FormControl(0),
      checkbox28: new FormControl(0),
      checkbox29: new FormControl(0),
      checkbox30: new FormControl(0),
      checkbox31: new FormControl(0),
      checkbox32: new FormControl(0),
      checkbox33: new FormControl(0),
      checkbox34: new FormControl(0),
      checkbox35: new FormControl(0),
      checkbox36: new FormControl(0),
    });
  }

  editCheckboxNote1(res): void {
    this.note1Form.patchValue({
      checkbox1: res.checkbox1,
      checkbox2: res.checkbox2,
      checkbox3: res.checkbox3,
      checkbox4: res.checkbox4,
      checkbox5: res.checkbox5,
      checkbox6: res.checkbox6,
      checkbox7: res.checkbox7,
      checkbox8: res.checkbox8,
      checkbox9: res.checkbox9,
      checkbox10: res.checkbox10,
      checkbox11: res.checkbox11,
      checkbox12: res.checkbox12,
      checkbox13: res.checkbox13,
      checkbox14: res.checkbox14,
      checkbox15: res.checkbox15,
      checkbox16: res.checkbox16,
      checkbox17: res.checkbox17,
      checkbox18: res.checkbox18,
      checkbox19: res.checkbox19,
      checkbox20: res.checkbox20,
      checkbox21: res.checkbox21,
      checkbox22: res.checkbox22,
      checkbox23: res.checkbox23,
      checkbox24: res.checkbox24,
      checkbox25: res.checkbox25,
      checkbox26: res.checkbox26,
      checkbox27: res.checkbox27,
      checkbox28: res.checkbox28,
      checkbox29: res.checkbox29,
      checkbox30: res.checkbox30,
      checkbox31: res.checkbox31,
      checkbox32: res.checkbox32,
      checkbox33: res.checkbox33,
      checkbox34: res.checkbox34,
      checkbox35: res.checkbox35,
      checkbox36: res.checkbox36,
    });
  }

  editNotes1(res): void {
    const patchObj = {};

    for (let i = 1; i <= 36; i++) {
      const key = `textbox${i}`;
      patchObj[key] = res[key] ? res[key] : '';
    }

    this.note1Form.patchValue(patchObj);
  }
}
